import { Component, OnInit } from '@angular/core';

import { NgxUiLoaderService } from 'ngx-ui-loader';

import { BuyerService } from '../_services/buyer.service';
import { BuyerPedidosService } from '../pedidos/pedidos.service';
import { NotificationService } from 'app/_services/notification.service';

import { ApiResponseModel } from 'app/_models/apiResponseModel';
import { BuyerOrdersGetByQuotationId } from '../_models/buyerOrdersGetByQuotationId';
import { BuyerOrdersGetOrdersHistoryResponseModel } from './_models/buyerOrdersGetOrdersHistoryResponseModel';
import { Globals } from 'app/_models/globals';
import { StatusIdEnum, isOldStatusConfirmado } from 'app/_models/statusId';

declare const copyToClipboard: any;
declare const deepSetObj: any;
declare const isEmpty: any;

@Component({
    selector: 'app-historico', templateUrl: './historico.component.html', styleUrls: ['./historico.component.scss'],
    standalone: false
})
export class BuyerHistoricoComponent implements OnInit {
    activeAccordionItemIndex: number | null;
    _filtro_status: string;
    searchTerm: string;
    deliveryTimes: any[];
    feriados: string[];
    agrupamentos: any;
    agrupamentosFiltrados: any;

    ja_pesquisou: boolean = false;

    constructor(private buyerService: BuyerService, private pedidosService: BuyerPedidosService, private notificationService: NotificationService, private globals: Globals, private ngxLoader: NgxUiLoaderService) { }

    ngOnInit() {
        this.agrupamentos = [];
        this.agrupamentosFiltrados = [];
        this.filtroStatus = '0';
        this.searchTerm = '';
    }

    atualizarPedidosFiltrados() {
        var agrupamentosFiltrados = this.filtrarPedidos();
        this.agrupamentosFiltrados = agrupamentosFiltrados;
    }

    atualizarPedidoSelecionado(param) {
        var quotation_id = param.quotation_id;
        var agrupamento = this.agrupamentos.find(p => p.transaction_id === quotation_id);

        if (isEmpty(agrupamento))
            return;

        agrupamento.loading_pedido = true;

        this.pedidosService.getByQuotationId(quotation_id).subscribe({
            next: (response: ApiResponseModel<BuyerOrdersGetByQuotationId>) => {
                agrupamento.loading_pedido = false;

                if (response && response.success) {
                    const result = response.result;

                    result.order.fotos = result.photos;

                    deepSetObj(agrupamento, result.order);

                    if (!isEmpty(agrupamento)) {
                        for (let pedido of agrupamento.pedidos) {
                            pedido = this.buyerService.atualizarTotais(pedido);
                            pedido.isCashbackCustomizado = pedido.had_cashback && pedido.pecas.some(p => p.desconto_original != p.desconto);
                            pedido.isCashbackPadronizado = pedido.had_cashback && !pedido.isCashbackCustomizado;
                        }
                    }

                    this.buyerService.handleEditionInformationsLoad(agrupamento, this.deliveryTimes, this.feriados);
                }

                this.ngxLoader.stopLoader('loader-principal');
            },
            error: error => {
                console.log(error);
                agrupamento.loading_pedido = false;
            }
        });
    }

    copiarClipboard(agrupamento: any) {
        let texto = `${agrupamento.veiculo} - Chassi: ${agrupamento.chassi_formatado}`;

        if (isEmpty(texto))
            return;

        texto = texto.trim();
        copyToClipboard(texto);
    }

    filtrar(nAttempts: number) {
        this.ngxLoader.startLoader('loader-principal');

        let filtro = this.searchTerm.replace('-', '');

        this.pedidosService.listOrdersHistory(filtro).subscribe({
            next: (response: ApiResponseModel<BuyerOrdersGetOrdersHistoryResponseModel>) => {
                this.ja_pesquisou = true;

                if (response != null) {
                    this.agrupamentos = response.result.orders;
                    this.deliveryTimes = response.result.deliveryTimes;

                    let holidays = response.result.holidays;
                    this.feriados = !isEmpty(holidays) ? holidays.map(h => h.replace('T05:00:00', '')) : [];

                    if (!isEmpty(this.agrupamentos)) {
                        for (let agrupamento of this.agrupamentos) {
                            for (let pedido of agrupamento.pedidos) {
                                pedido = this.buyerService.atualizarTotais(pedido);
                                pedido.min_status = Math.min.apply(Math, pedido.pecas.map(p => p.status));
                            }
                        }
                    }

                    this.atualizarPedidosFiltrados();
                }

                this.ngxLoader.stopLoader('loader-principal');
            },
            error: error => {
                nAttempts = nAttempts || 1;
                console.log(error, nAttempts);

                if (nAttempts >= 5) {
                    this.ngxLoader.stopLoader('loader-principal');
                    this.notificationService.showErrorToastr(this.globals.translate('buyer.pedidos.mensagens.erro.carregamento.corpo'));
                    return;
                }

                this.filtrar(++nAttempts);
            }
        });
    }

    filtrarPedidos() {
        if (isEmpty(this.agrupamentos))
            return this.agrupamentos;

        var agrupamentosFiltrados =
            this.agrupamentos.filter(
                a => a.pedidos.filter(
                    p => p.pecas.filter(pe =>
                        {
                            switch (this._filtro_status)
                            {
                                case '0':
                                    return true;
                                case '1': // em análise
                                    return pe.status === StatusIdEnum.EmAnalise;
                                case '2': // aguardando entrega
                                    return isOldStatusConfirmado(pe.status);
                                case '3': // entregue
                                    return pe.status === StatusIdEnum.Entregue;
                                case '4': // rejeitado
                                    return pe.status >= StatusIdEnum.CotacaoCanceladaComprador;
                                default:
                                    return false;
                            }
                    }).length > 0
                ).length > 0);

        return agrupamentosFiltrados;
    }

    toggleAgrupamento(agrupamento: any, agrupamentoIndex: number) {
        this.activeAccordionItemIndex = agrupamentoIndex != this.activeAccordionItemIndex ? agrupamentoIndex : null

        this.copiarClipboard(agrupamento);
    }

    get filtroStatus(): string {
        return this._filtro_status;
    }

    set filtroStatus(value: string) {
        this._filtro_status = value;
        this.atualizarPedidosFiltrados();
    }
}
